import {DataGrid} from '@mui/x-data-grid';
import {styled} from "@mui/material";

export const GridDiv = styled('div')({
    height: 'auto',
    width: '100%'
});

export const StyledGridOverlay = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: "relative",
    zIndex: 1,
    height: '100%',
    margin: '10px',
    '& .ant-empty-img-1': {
        fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
    },
    '& .ant-empty-img-2': {
        fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
    },
    '& .ant-empty-img-3': {
        fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
    },
    '& .ant-empty-img-4': {
        fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
    },
    '& .ant-empty-img-5': {
        fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
        fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
    },
}));

export const StyledDataGrid = styled(DataGrid)({
    width: '90%',
    margin: "20px 50px",
    boxShadow: '0 2px 10px rgba(46, 55, 93, 0.2)',
    background: 'transparent',
    borderRadius: '6px',

    '&. MuiDataGrid-withBorderColor': {
        borderColor: '#DCEBC0',
    },

    '& .MuiDataGrid-columnHeaders': {
        background: '#9DD4CF'
    },

    '& .MuiDataGrid-columnHeader:focus': {
        outline: 'none'
    },

    '& .MuiDataGrid-columnHeader:focus-within': {
        outline: 'none'
    },

    '& .MuiDataGrid-cell:focus': {
        outline: 'none'
    },

    '& .MuiDataGrid-cell:focus-within': {
        outline: 'none'
    },

    '& .MuiDataGrid-columnHeaderTitle': {
        color: '#48556D',
        fontWeight: '400',
        fontSize: '16px'
    },

    '& .MuiDataGrid-cell': {
        color: '#86BC25',
        verticalAlign: 'middle',
    },

    '.MuiDataGrid-row.Mui-selected': {
        backgroundColor: '#f1f7e6',

        '&.Mui-hovered': {
            backgroundColor: '#f1f7e6',
        }
    },

    '& .inactive': {
        backgroundColor: '#e5e5e5',
        '&:hover': {
            backgroundColor: '#d2d2d2'
        },
        '&.Mui-selected': {
            backgroundColor: '#e5e5e5',
            '&:hover': {
                backgroundColor: '#d2d2d2',
            },
        },
    },
});